
import "./maxretry.scss";

const MaxRetry = () => {
  return (
    <div className="maxRetryPage">
        <div className="headline">
            <h1>Maximum Retries Reached</h1>
            <div className="description">
                Sorry but it looks like you've used up all your retries. You will no longer be able to continue the exam.
            </div>
        </div>
    </div>
    );
};

export default MaxRetry;
